import { object } from 'yup'

import { getSchema as getCompetenciesSchema } from './tabs/Competencies/schema'
import { getSchema as getDetailsSchema } from './tabs/Details/schema'
import { getSchema as getModulesSchema } from './tabs/Modules/schema'
import { getSchema as getOutcomesSchema } from './tabs/PrioritisedOutcome/schema'
import { getSchema as getAccessSchema } from './tabs/Access/schema'

export const getSchema = isPositionManagement =>
  object().shape({
    ...getCompetenciesSchema().fields,
    ...getDetailsSchema(isPositionManagement).fields,
    ...getModulesSchema().fields,
    ...getOutcomesSchema().fields,
    ...getAccessSchema().fields,
  })
